import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=32c4d38d&scoped=true"
import script from "./PreLoader.vue?vue&type=script&lang=js"
export * from "./PreLoader.vue?vue&type=script&lang=js"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=32c4d38d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c4d38d",
  null
  
)

export default component.exports